<template>
    <v-app>
        <v-row class="justify-content-center">
            <v-col cols="12" md="10" class="justify-content-center">

                <archive-filters :searchParamOptions="searchParamOptions" :searchParams="searchParams" @submitSearch="submitSearch"></archive-filters>

                <div v-if="!loading && !submissions.length" class="pt-8">
                    <v-row class="justify-content-center">
                        <v-alert color="yellow lighten-3" elevation="4">
                            {{lang().get('scheduling.archive.empty')}}
                        </v-alert>
                    </v-row>
                </div>

                <div v-if="!loading && submissions.length" id="archiveList">
                    <archive-list-item
                        v-for="submission in submissions"
                        :key="submission.id"
                        :id="submission.id"
                        :text="submission.text"
                        :status="submission.status"
                        :image_url="submission.image_url"
                        :submission_time="submission.submission_time"
                        :decision_time="submission.decision_time"
                        :scheduled_post_time="submission.scheduled_post_time"
                        :hit_filter="submission.filter_hit ? true : false"
                        :route_truth_details="submission.route_truth_details"
                        :numbered="submission.numbered ? true : false"
                        :header_text="submission.header_text"
                        :nsfw_probability="submission.nsfw_probability"
                        :posted_time="submission.post ? submission.post.time_posted : null"
                        :filter_phrases="submission.filter_phrases"
                        :post_link="submission.post ? `https://facebook.com/${submission.post.fb_post_id}` : null"
                        :instagram="submission.post_to_instagram ? true : false"
                    ></archive-list-item>
                </div>

                <div v-if="loading" class="text-center pt-3">
                    <v-progress-circular
                        indeterminate
                        :size="50"
                        :width="5"
                    ></v-progress-circular>
                </div>

                <nav v-if="!loading && pagination.last_page > 1" aria-label="Page navigation">
                    <ul class="pagination mb-0">
                        <li :class="[{disabled: !pagination.prev_page_url}]" class="page-item">
                            <a class="page-link" href="#" @click="fetchSubmissions(pagination.prev_page_url)">Previous</a>
                        </li>

                        <li class="page-item disabled">
                            <a
                            class="page-link text-dark"
                            href="#"
                            >Page {{ pagination.current_page }} of {{ pagination.last_page }}</a>
                        </li>

                        <li :class="[{disabled: !pagination.next_page_url}]" class="page-item">
                            <a class="page-link" href="#" @click="fetchSubmissions(pagination.next_page_url)">Next</a>
                        </li>
                    </ul>
                </nav>
            </v-col>
        </v-row>
    </v-app>
</template>


<script>
import ArchiveListItem from './ArchiveListItem';
import ArchiveFilters from './ArchiveFilters';

export default {
  name: "ArchiveRoot",

  components: {
    ArchiveListItem,
    ArchiveFilters
  },

  props: {
      searchParamOptions: {
          type: Object,
          required: true,
      },
  },

  data() {
    return {
      loading: true,
      submissions: [],
      pagination: [],
      searchParams: {
        text: '',
        status: '',
        admin: '',
        urgent: '',
        image: '',
        order: this.searchParamOptions.order[0].value,
        sortParam: this.searchParamOptions.sortParam[0].value
      }
    };
  },

  created() {
    this.fetchSubmissions();
  },

  methods: {
      submitSearch() {
          this.fetchSubmissions();
      },

    cleanParams(params) {
        let cleanedParams = {};
        for (const [key, value] of Object.entries(params)) {
            if (value || value === 0) {
                cleanedParams[key] = value;
            }
        }
        return cleanedParams;
    },

    fetchSubmissions(page_url) {
      this.loading = true;
      let self = this;
      page_url = page_url || "/api/archive";
      axios
        .get(page_url, {
          params: self.cleanParams(self.searchParams)
        })
        .then(function(response) {
          self.loading = false;
          // convert to an array (so we can easily get the length). Strange we have to data.data but something to do with pagination
          self.submissions = Object.values(response.data.data);
          self.makePagination(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    makePagination(response) {
      let pagination = {
        current_page: response.current_page,
        last_page: response.last_page,
        next_page_url: response.next_page_url,
        prev_page_url: response.prev_page_url
      };
      this.pagination = pagination;
    },
  }
};
</script>
